<template>
    <div class="batchExamine" v-loading='loading'>
        <div class="tableBox">
            <ux-grid
                class="uxGridBox"
                ref="plxTable"
                show-footer-overflow="tooltip"
                show-overflow="tooltip"
                keep-source
                :edit-config="{trigger: 'manual', mode: 'row'}"
                size="mini">
                <ux-table-column
                    v-for="item in columns"
                    :key="item.id"
                    :resizable="item.resizable"
                    :field="item.prop"
                    :title="item.label"
                    :width="item.width"
                    show-header-overflow='tooltip'
                    :fixed="item.fixed"
                    align="center">
                    <template v-slot="{ row }">
                        <span :style="row['original_' + item.prop]&&row[item.prop] && (row['original_' + item.prop] != row[item.prop])&&((item.prop).indexOf('original_')==-1)?'color:red':''">{{row[item.prop]}}</span>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <div class="writeBox">
            <p class="title">修改原因：</p>
            <div class="writeItem" style="width:80%;margin-top:0">
                {{orderList.reason}}
            </div>
        </div>
        <div class="writeBox">
            <p class="title">审核意见：</p>
            <div class="writeItem" style="width:90%">
                <el-input class="input" type="textarea" v-model.trim="verify_note" placeholder="请输入审核意见" size='mini'></el-input>
            </div>
        </div>
        <!-- button  -->
        <div class="buttones">
            <button class="yes" @click="verifyEvent(1)">审核通过</button>
            <button class="yes" style="background:#d51313;border-color:#d51313;" @click="verifyEvent(0)">审核不通过</button>
            <button @click="orderCancelClick">取消</button>
        </div>
    </div>
</template>
<script>
import columnsJson from '@/components/Order/json/batchExamine.js'
export default {
    props:['edit_id'],
    data(){
        return{
            orderList:[],
            loading:false,
            verify_note:'',
            userInfo:{},
            columns:columnsJson
        }
    },
    created(){
        this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
        this.getOrderList()
    },
    methods:{
        verifyEvent(source){
            if(source != 1 && this.verify_note==''){
                this.$message({
                    message: '请输入审核意见',
                    type: 'warning'
                })
                return;
            }
            this.$confirm(source==1?'确定审核通过该订单吗?':(source==0?'确定驳回该订单？':''), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.loading = true;
                    this.$axios.post(this.URL.BASEURL + this.URL.verifyOrderEdit,{
                        id: this.edit_id,
                        verify_status: source == 1 ? ((this.userInfo.role_id==13 || this.userInfo.role_id==15) ? 2 : 4) : ((this.userInfo.role_id==13 || this.userInfo.role_id==15) ? 3 : 5),
                        verify_note: this.verify_note
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.$emit('emit_refresh')
                        }else {
                            this.loading = false;
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                        this.loading = false;
                    })
                }).catch(() => {     
            });
        },
        orderCancelClick(){
            this.$emit('cancelToast')
        },
        getOrderList(){
            this.loading = true;
            this.$axios.get(this.URL.BASEURL + this.URL.getOrderEditingDetail,{
                params:{
                   edit_id:this.edit_id
                }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.orderList = res.rst;
                    this.datas = res.rst.order // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
                    this.$refs.plxTable.reloadData(this.datas)
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false;
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.writeBox{
    margin-top: 10px;
    padding-bottom: 0px;
    .title{
        color: #202652;
        font-size: 15px;
        line-height: 21px;
        font-weight: 500;
        margin-top: 10px;
        display: inline-block;
    }
    .writeItem{
        display: inline-block;
        width: 33%;
        vertical-align: middle;
        margin-top: 4px;
        font-size: 12px;
        label{
            color: #202652;
            line-height: 20px;
            display: inline-block;
            vertical-align: middle;
        }
        span{
            line-height: 20px;
        }
        &.change{
            label{
                color: red;
            }
            span{
                color: red;
            }
        }
        em{
            padding-left: 6px;
            vertical-align: middle;
        }
        .input{
            width: calc(100% - 200px);
            display: inline-block;
        }
    }
}
.buttones{
    text-align: center;
    margin-top: 30px;
    button{
        width: 91px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #dcdfe5;
        color: #202652;
        font-size: 14px;
        background: transparent;
        margin: 0 4px;
    }
    .yes{
        border-color:#5B7BFE ;
        background: #5B7BFE;
        color: #ffffff;
    }
    
}
</style>
<style lang="scss">
.batchExamine{
    .thAE{
        background: #E3E9F3 !important;
    }
    .thMedium{
        background: #F6E6E6 !important;
    }
    .thFinance{
        background: #E6F3F3 !important;
    }
    .thTotal{
        background: #eff0f2 !important;
    }
    .thActive{
        color: red !important;
    }
    .el-table{
        font-size: 12px !important;
    }
    .el-date-editor .el-range-separator{
        width: 10%;
    }
    .el-input--suffix .el-input__inner{
        padding-right: 10px !important;
    }
    .el-table th>.cell{
        padding-left:4px !important ;
        padding-right:4px !important ;
    }
    .el-table td, .el-table th{
        padding: 5px 0 !important;
    }
    .numberInput .el-input__inner{
        padding: 0 4px !important;
        text-align: center !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/examine/batchExaminePdd.vue